import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CREATE_BOOKING_360, CREATE_BOOKING_360_SUCCESS, CREATE_BOOKING_360_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* createBooking360({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/create-manual-booking-draft`,
      method: 'POST',
      data: payload.data,
      // isFormData: true,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: CREATE_BOOKING_360_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CREATE_BOOKING_360_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_BOOKING_360_ERROR, payload: error });
  }
}

export function* watchCreateBooking360() {
  yield takeEvery(CREATE_BOOKING_360, createBooking360);
}

function* createBooking360Saga() {
  yield all([fork(watchCreateBooking360)]);
}

export default createBooking360Saga;
